import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

const CourseHistoryColumnView = () => {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper>
      <Column width={100} style={{marginLeft: '20px'}}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colDate')}</Text>
      </Column>
      <Column width={200}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colLesson')}</Text>
      </Column>
      <Column width={65}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colTime')}</Text>
      </Column>
      <Column width={100}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colInstructor')}</Text>
      </Column>
      <Column width={177}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colUsedMembership')}</Text>
      </Column>
      <Column width={100}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colDeduction')}</Text>
      </Column>
      <Column width={80}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.colStatus')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

export default CourseHistoryColumnView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 34px 0px 20px 0px;

  width: 970px;

  gap: 10px;

  transition: all 0.3s ease-in-out;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }

  transition: all 0.3s ease-in-out;
`;
